var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69379",
    "data-name": "Group 69379",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.941,
    height: 143.954,
    viewBox: "0 0 150.941 143.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141860",
    "data-name": "Rectangle 141860",
    width: 150.941,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86087",
    "data-name": "Path 86087",
    d: "M65.146,58.036c-1.393,1.035-41.585,1.832-44.992,11.817s28.218,34.577,28.761,36.674-9.537,40.539-1.99,45.72c4.193,2.879,16.435-2.224,26.856-7.328,8.338-4.083,15.511-8.166,16.462-8.161,2.137.012,37.187,20.566,43.317,15.489s-2.025-44.568-1.285-46.423,31.273-28.43,28.058-35.971-42.689-10.82-44.288-11.817-15.33-39.106-25.8-39.106S66.537,57,65.146,58.036",
    transform: "translate(-19.897 -18.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 0.849,
    x2: 0.127,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#ffeb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ffd54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141858",
    "data-name": "Rectangle 141858",
    width: 80.004,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141856",
    "data-name": "Rectangle 141856",
    width: 18.119,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141857",
    "data-name": "Rectangle 141857",
    width: 18.118,
    height: 16.728,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69378",
    "data-name": "Group 69378",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69364",
    "data-name": "Group 69364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69363",
    "data-name": "Group 69363",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86086",
    "data-name": "Path 86086",
    d: "M75.484,0c11.236,0,26.723,39.375,28.438,40.444s43.31,6.1,46.759,14.19S122.126,91.99,121.334,93.982s7.2,43.6.624,49.051S77.777,127.182,75.484,127.17,37.108,148.592,29.01,143.033s1.209-46.8.626-49.051S-3.368,65.345.287,54.633s45.267-13.08,46.76-14.19S64.25,0,75.484,0",
    transform: "translate(0)",
    fill: "#ffbd39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69366",
    "data-name": "Group 69366",
    transform: "translate(5.139 4.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69365",
    "data-name": "Group 69365",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141855",
    "data-name": "Rectangle 141855",
    width: 201.367,
    height: 200.285,
    transform: "matrix(0.769, -0.64, 0.64, 0.769, -71.201, 56.65)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69377",
    "data-name": "Group 69377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69376",
    "data-name": "Group 69376",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86088",
    "data-name": "Path 86088",
    d: "M56.321,201.539c-.728-7.1,22.564-11.279,23.593-2.971s-22.6,12.645-23.593,2.971",
    transform: "translate(-41.763 -143.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86089",
    "data-name": "Path 86089",
    d: "M170.8,192.123c-.175-4.567,6.79-4.846,7.152-1.1.405,4.194-6.988,5.37-7.152,1.1",
    transform: "translate(-126.685 -139.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69375",
    "data-name": "Group 69375",
    transform: "translate(35.468 81.235)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69374",
    "data-name": "Group 69374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69373",
    "data-name": "Group 69373",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69369",
    "data-name": "Group 69369",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69368",
    "data-name": "Group 69368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69367",
    "data-name": "Group 69367",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86090",
    "data-name": "Path 86090",
    d: "M155.45,322.9c0,4.618-4.056,8.365-9.059,8.365s-9.06-3.747-9.06-8.365,4.056-8.363,9.06-8.363,9.059,3.744,9.059,8.363",
    transform: "translate(-137.331 -314.536)",
    fill: "#ff5f82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69372",
    "data-name": "Group 69372",
    transform: "translate(61.887)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69371",
    "data-name": "Group 69371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69370",
    "data-name": "Group 69370",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86091",
    "data-name": "Path 86091",
    d: "M395.071,322.9c0,4.618-4.056,8.365-9.059,8.365s-9.059-3.747-9.059-8.365,4.055-8.363,9.059-8.363,9.059,3.744,9.059,8.363",
    transform: "translate(-376.953 -314.536)",
    fill: "#ff5f82"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86092",
    "data-name": "Path 86092",
    d: "M269.365,357.613c-.6.632-6.249-2.092-12.637-2.089-6.454,0-12.233,2.728-12.843,2.089-1.216-1.272,2.306-13.033,12.734-13.033s13.945,11.761,12.746,13.033",
    transform: "translate(-180.727 -255.586)",
    fill: "#872a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86093",
    "data-name": "Path 86093",
    d: "M349.784,241.084c-.971-2.263-18.662,6.4-18.321,11s16.5,9.99,18.547,7.576-10.694-5.454-10.807-8.031,11.947-7.354,10.582-10.54",
    transform: "translate(-245.853 -178.545)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86094",
    "data-name": "Path 86094",
    d: "M180.733,241.084c.971-2.263,18.662,6.4,18.321,11s-16.5,9.99-18.547,7.576,10.695-5.454,10.808-8.031-11.948-7.354-10.583-10.54",
    transform: "translate(-133.723 -178.545)",
    fill: "#541300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating1);
export default __webpack_public_path__ + "static/media/rating-1.4ac84508e55731b28b45a68216e019ca.svg";
export { ForwardRef as ReactComponent };